import { render, staticRenderFns } from "./TaskDetailPanel.vue?vue&type=template&id=6e2d2eb5&"
import script from "./TaskDetailPanel.vue?vue&type=script&lang=ts&"
export * from "./TaskDetailPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetailPanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports